"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderFromUrl = exports.isSignInRedirect = exports.StytchAuthFactorOtpProvider = exports.StytchOtpProvider = exports.WebAuthnProvider = exports.AppleProvider = exports.GoogleProvider = exports.EthWalletProvider = exports.DiscordProvider = exports.BaseProvider = void 0;
const tslib_1 = require("tslib");
const _LitAuthClient = require("./lib/lit-auth-client");
const BaseProvider_1 = require("./lib/providers/BaseProvider");
Object.defineProperty(exports, "BaseProvider", { enumerable: true, get: function () { return BaseProvider_1.BaseProvider; } });
const DiscordProvider_1 = require("./lib/providers/DiscordProvider");
exports.DiscordProvider = DiscordProvider_1.default;
const EthWalletProvider_1 = require("./lib/providers/EthWalletProvider");
exports.EthWalletProvider = EthWalletProvider_1.default;
const GoogleProvider_1 = require("./lib/providers/GoogleProvider");
exports.GoogleProvider = GoogleProvider_1.default;
const AppleProvider_1 = require("./lib/providers/AppleProvider");
exports.AppleProvider = AppleProvider_1.default;
const WebAuthnProvider_1 = require("./lib/providers/WebAuthnProvider");
exports.WebAuthnProvider = WebAuthnProvider_1.default;
const StytchOtpProvider_1 = require("./lib/providers/StytchOtpProvider");
Object.defineProperty(exports, "StytchOtpProvider", { enumerable: true, get: function () { return StytchOtpProvider_1.StytchOtpProvider; } });
const utils_1 = require("./lib/utils");
Object.defineProperty(exports, "isSignInRedirect", { enumerable: true, get: function () { return utils_1.isSignInRedirect; } });
Object.defineProperty(exports, "getProviderFromUrl", { enumerable: true, get: function () { return utils_1.getProviderFromUrl; } });
const StytchAuthFactorOtp_1 = require("./lib/providers/StytchAuthFactorOtp");
exports.StytchAuthFactorOtpProvider = StytchAuthFactorOtp_1.default;
const LitAuthClient = _LitAuthClient.LitAuthClient;
if (!globalThis.LitAuthClient) {
    globalThis.LitAuthClient = LitAuthClient;
}
tslib_1.__exportStar(require("./lib/lit-auth-client"), exports);
//# sourceMappingURL=index.js.map